import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem } from '@mui/material';
import './GreenLights.css';

const GreenLights = ({ greenFlags }) => {
  const flags = greenFlags && Array.isArray(greenFlags) ? greenFlags : [];

  const formatAspect = (s) =>
    (s || '')
      .replace(/\band\b/g, '&')
      .split(' ')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

  return (
    <Card className="component-green-light" sx={{ borderRadius: "12px", boxShadow: "none", border: "none" }}>
      <CardContent className="header">
        <Typography className="title">Green Lights</Typography>
      </CardContent>
      <CardContent className="content">
        <List>
          {flags.length > 0 ? (
            flags.map((item, index) => (
              <ListItem key={index} className="list-item">
                <Box className="list-text">
                  <Typography component="div" className="positive_aspect">
                    {formatAspect(item.positive_aspect)}
                  </Typography>
                  <Typography component="div" className="timestamp">
                    {item.timestamp ? `Timestamp: ${item.timestamp}` : 'Timestamp: Not specified'}
                  </Typography>
                  <Typography component="div" className="list-details">
                    {item.context || ''}
                  </Typography>
                </Box>
              </ListItem>
            ))
          ) : (
            <Typography className="no-scores">No green lights detected</Typography>
          )}
        </List>
      </CardContent>
    </Card>
  );
};

export default GreenLights;